import automationStateManager from "../AutomationStateManager";
import automationSequenceRuntimeStateManager from "../AutomationSequenceRuntimeStateManager";

const RUNTIME_STORAGE_KEY = "automationSequenceRuntimeState";
const RUNTIME_TAB_KEY = `${RUNTIME_STORAGE_KEY}:activeTab`;
const RUNTIME_ARCHIVE_PREFIX = `${RUNTIME_STORAGE_KEY}:invalid`;

const removeRuntimeArchiveKeys = () => {
  if (typeof window === "undefined" || !window.localStorage) return;

  const keysToRemove = [];
  for (let index = 0; index < window.localStorage.length; index += 1) {
    const key = window.localStorage.key(index);
    if (key?.startsWith(RUNTIME_ARCHIVE_PREFIX)) {
      keysToRemove.push(key);
    }
  }

  keysToRemove.forEach((key) => {
    try {
      window.localStorage.removeItem(key);
    } catch {
      // no-op
    }
  });
};

/**
 * Clears browser-local automation recovery and modal state for this device.
 * Does not change routines, schedules, classes, or lesson content in Firestore.
 * Does not clear steps the teacher manually closed today (Stop / close) — those
 * stay suppressed so Clear State cannot trap you in a catch-up loop.
 */
export const clearLocalAutomationState = () => {
  automationStateManager.clearState();
  automationSequenceRuntimeStateManager.resetAutomationState();

  if (typeof window === "undefined" || !window.localStorage) return;

  try {
    window.localStorage.removeItem(RUNTIME_TAB_KEY);
  } catch {
    // no-op
  }

  removeRuntimeArchiveKeys();
};

export default clearLocalAutomationState;
